'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _Functions = require('../core/Functions');

var _memoizeOne = require('react-utils/memoizeOne');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _deprecated = require('../utils/propTypes/deprecated');

var _deprecated2 = _interopRequireDefault(_deprecated);

var _UIClickable = require('../button/UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _decorators = require('../utils/propTypes/decorators');

var _component = require('../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getOnOverlayClickWarning = function getOnOverlayClickWarning() {
  return {
    message: 'UIOverlay: The `onOverlayClick` prop is deprecated. ' + 'Please do not trigger actions from an overlay click.',
    key: 'onOverlayClick',
    url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/6046'
  };
};

var getStyle = function getStyle(style, centerContent, width) {
  return centerContent ? _extends({}, style, { maxWidth: width }) : style;
};

var USE_CLASSES = {
  dark: '',
  light: 'private-overlay--light'
};

var UIOverlay = function (_React$Component) {
  _inherits(UIOverlay, _React$Component);

  function UIOverlay(props) {
    _classCallCheck(this, UIOverlay);

    var _this = _possibleConstructorReturn(this, (UIOverlay.__proto__ || Object.getPrototypeOf(UIOverlay)).call(this, props));

    _this._getStyle = (0, _memoizeOne2.default)(getStyle);
    _this.handleClick = _this.handleClick.bind(_this);
    _this.outerRefCallback = _this.outerRefCallback.bind(_this);
    _this.innerRefCallback = _this.innerRefCallback.bind(_this);
    return _this;
  }

  _createClass(UIOverlay, [{
    key: 'handleClick',
    value: function handleClick(evt) {
      var _props = this.props,
          onClick = _props.onClick,
          onOverlayClick = _props.onOverlayClick;
      var target = evt.target;

      (0, _Functions.callIfPossible)(onClick, evt);
      if (target === this._outerEl || target === this._innerEl) {
        (0, _Functions.callIfPossible)(onOverlayClick, evt);
      }
    }
  }, {
    key: 'outerRefCallback',
    value: function outerRefCallback(ref) {
      this._outerEl = (0, _reactDom.findDOMNode)(ref);
    }
  }, {
    key: 'innerRefCallback',
    value: function innerRefCallback(ref) {
      this._innerEl = ref;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          centerContent = _props2.centerContent,
          children = _props2.children,
          className = _props2.className,
          contextual = _props2.contextual,
          onClick = _props2.onClick,
          onOverlayClick = _props2.onOverlayClick,
          style = _props2.style,
          tabIndex = _props2.tabIndex,
          use = _props2.use,
          width = _props2.width,
          Inner = _props2.Inner,
          rest = _objectWithoutProperties(_props2, ['centerContent', 'children', 'className', 'contextual', 'onClick', 'onOverlayClick', 'style', 'tabIndex', 'use', 'width', 'Inner']);

      var isSandboxed = contextual || this.context.sandboxed;

      var computedClassName = (0, _classNames2.default)(className, 'private-overlay', 'uiOverlay-backdrop', USE_CLASSES[use], {
        'private-overlay--contextual': isSandboxed
      });

      var computedChildrenWrapperClassName = (0, _classNames2.default)({
        'private-modal__container': centerContent
      });

      var isClickable = onClick || onOverlayClick;
      var Overlay = isClickable ? _UIClickable2.default : 'div';
      var overlayProps = isClickable ? { cursor: 'auto' } : undefined;

      return _react2.default.createElement(
        Overlay,
        _extends({}, rest, overlayProps, {
          className: computedClassName,
          onClick: this.handleClick,
          ref: this.outerRefCallback,
          role: 'presentation',
          tabIndex: isSandboxed ? null : tabIndex
        }),
        _react2.default.createElement(
          Inner,
          {
            className: computedChildrenWrapperClassName,
            ref: this.innerRefCallback,
            style: this._getStyle(style, centerContent, width)
          },
          children
        )
      );
    }
  }]);

  return UIOverlay;
}(_react2.default.Component);

UIOverlay.propTypes = {
  centerContent: _react.PropTypes.bool.isRequired,
  children: _react.PropTypes.node,
  contextual: _react.PropTypes.bool.isRequired,
  onOverlayClick: (0, _deprecated2.default)(_react.PropTypes.func, getOnOverlayClickWarning),
  use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)),
  width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]).isRequired,
  Inner: (0, _decorators.hidden)(_component2.default)
};

UIOverlay.contextTypes = {
  sandboxed: _react.PropTypes.bool
};

UIOverlay.defaultProps = {
  centerContent: true,
  contextual: false,
  use: 'dark',
  Inner: 'div'
};

UIOverlay.displayName = 'UIOverlay';

exports.default = UIOverlay;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/overlay/UIOverlay.js
// module id = 539
// module chunks = 171